import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexTypeAttribute } from "../model/IndexTypeAttribute";
import IndexTypeAttributeMapper from "../service/IndexTypeAttributeMapper";
import IndexTypeAttributeParamMapper from "../service/IndexTypeAttributeParamMapper";

export default class GetAllIndexTypeAttributesInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexTypeAttribute>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(indexTypeId: number) {
    return this.resource.execute(
      `${Constants.indexTypeAttributePath}/${indexTypeId}`,
      IndexTypeAttributeMapper,
      IndexTypeAttributeParamMapper
    );
  }
}
